// @flow
import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import ReactDOM from 'react-dom'
import registerServiceWorker from './registerServiceWorker'

// Pages.
import Home from './pages/Home'
import TermnsConditions from './pages/TermnsConditions'
import VerifyAccount from './pages/VerifyAccount'
import ResetPassword from './pages/ResetPassword'
import SendMoneyNoWink from './pages/SendMoneyNoWink'
import CreditAccountNoWink from './pages/CreditAccountNoWink'
import ConfirmEmail from './pages/ConfirmEmail'
import RequestChangeEmail from './pages/RequestChangeEmail'
import WinkReferral from './pages/Referral'
import ReferalTermsAndConditions from './pages/Referral/termsAndConditions'
import ReferalSucces from './pages/Referral/success'
import PayPal from './pages/PayPal'

const App = () =>
  <Router>
    <div>
      <Route
        exact
        path='/paypal/:token'
        component={PayPal}
      />
      <Route
        exact
        path='/referral/:name/:username'
        component={WinkReferral}
      />
      <Route
        exact
        path='/referral/termsAndConditions'
        component={ReferalTermsAndConditions}
      />
      <Route
        exact
        path='/referral/success'
        component={ReferalSucces}
      />
      <Route
        exact
        path='/verify-account/:username/:verificationCode'
        component={VerifyAccount}
      />
      <Route
        exact
        path='/auth-request-change-password/:username/:resetCode'
        component={ResetPassword}
      />
      <Route
        exact
        path='/request-change-password/:username/:resetCode'
        component={ResetPassword}
      />
      <Route
        exact
        path='/request-change-email/:email/:code'
        component={RequestChangeEmail}
      />
      <Route
        exact
        path='/send-money-no-wink/:encryp1/:encryp2'
        component={SendMoneyNoWink}
      />
      <Route
        exact
        path='/credit-account-no-wink/:encryp1/:encryp2'
        component={CreditAccountNoWink}
      />
      <Route
        exact
        path='/confirm-email'
        component={ConfirmEmail}
      />
      <Route
        exact
        path='/conditions'
        component={TermnsConditions}
      />
      <Route exact path='/' component={Home} />
    </div>
  </Router>

ReactDOM.render(<App />, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js